import dayjs from 'dayjs';

export const toTimestampText = (date: string) => {
	return dayjs(date).format('MMMM D YYYY');
};

